export default __webpack_public_path__ + "static/media/bg_grey_big.97bc02f5.svg";